import { render } from "./SmearForMalignantCells.vue?vue&type=template&id=b26ab644&scoped=true"
import script from "./SmearForMalignantCells.vue?vue&type=script&lang=js"
export * from "./SmearForMalignantCells.vue?vue&type=script&lang=js"

import "./SmearForMalignantCells.vue?vue&type=style&index=0&id=b26ab644&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b26ab644"]])

export default __exports__